import { FieldComponent } from "./chunk-GWGNVESG.js";
import { SelectComponent } from "./chunk-YSLKMR4F.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/SelectField/SelectField.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var TEXT_FIELD_CLASSNAME_MAP = {};
var SelectField = forwardRef((_a, ref) => {
  var _b = _a,
    {
      id,
      name,
      label,
      required,
      requiredLabel,
      description,
      validation,
      validationMessage,
      className
    } = _b,
    rest = __objRest(_b, ["id", "name", "label", "required", "requiredLabel", "description", "validation", "validationMessage", "className"]);
  return /* @__PURE__ */jsxs(FieldComponent, {
    id,
    name,
    label,
    required,
    requiredLabel,
    description,
    validation,
    validationMessage,
    className: clsx("pd:select-field", className),
    children: [/* @__PURE__ */jsx(FieldComponent.Label, {
      className: "pd:select-field__label"
    }), /* @__PURE__ */jsx(FieldComponent.Input, __spreadValues({
      ref,
      as: SelectComponent,
      className: "pd:select-field__input"
    }, rest)), /* @__PURE__ */jsx(FieldComponent.ValidationMessage, {
      className: "pd:select-field__validation-message"
    }), /* @__PURE__ */jsx(FieldComponent.Description, {
      className: "pd:select-field__description"
    })]
  });
});
var SelectField_default = SelectField;
export { TEXT_FIELD_CLASSNAME_MAP, SelectField_default };